import styled from 'styled-components';

export const UserMenuStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @media screen and (min-width: 768px) {
    padding-top: 10px;
    padding-bottom: 5px;
  }
`;
